import { ApiFragment, RecordType, UserFunctions } from '@stylehaven/components';
import { BulkUserAction } from '../../entities/common/bulk-user-action.entity';
import { ActionDisabledCondition, UserAction } from '../../entities/common/user-action.entity';

/* Share
 * Available when:
 *  * not deleted
 *  * not a representation
 *  * not in share context
 *  * User has MANAGE_SHARES userfunction or Portal user
 *
 * Disabled when:
 *   * Incomplete
 *   * Item has errors
 */
export function GetShareUserAction(
    record?: ApiFragment,
    userFunctions?: UserFunctions,
    inShareContext?: boolean,
    isPortalUser: boolean = false
): UserAction {
    const isDeleted: boolean = record?.isDeleted() ?? false;
    const isRepresentation: boolean = record?.getRecordType() === RecordType.Representation;
    const hasManageShares: boolean = (userFunctions?.MANAGE_SHARES || isPortalUser) ?? false;

    const isCompleted: boolean = record?.isCompleted() ?? false;
    const hasErrors: boolean = record?.hasSevereErrors() ?? false;

    const availableConditions: boolean[] = [!isDeleted, !isRepresentation, !inShareContext, hasManageShares];
    const disableConditions: ActionDisabledCondition[] = [
        { condition: !isCompleted, tooltip: 'general.blocked-status' },
        { condition: hasErrors, tooltip: 'general.blocked-status' }
    ];

    return new UserAction(availableConditions, disableConditions);
}

/* Bulk share
 * Available when:
 *  * not deleted
 *  * not a representation
 *  * not in share context
 *  * User has MANAGE_SHARES userfunction or Portal user
 *
 * Disabled when:
 *   * Incomplete
 *   * Item has errors
 *   * More than 500 records selected
 */
export function GetBulkShareUserAction(
    records: readonly ApiFragment[],
    userFunctions: UserFunctions,
    inShareContext: boolean
): BulkUserAction {
    const MAX_COUNT: number = 500;

    const lessThan500Records: boolean = records.length <= MAX_COUNT;

    const availableConditions: boolean[] = [];
    const disableConditions: ActionDisabledCondition[] = [
        {
            condition: !lessThan500Records,
            tooltip: 'general.too-many-items',
            tooltipOptions: { maxCount: MAX_COUNT }
        }
    ];

    return new BulkUserAction(
        records,
        availableConditions,
        disableConditions,
        GetShareUserAction,
        false,
        userFunctions,
        inShareContext
    );
}
